import Vue from 'vue';
import KEYS from '@/values/keys';
import EdLessonNavLink from '../ed-lesson-nav-link/ed-lesson-nav-link.vue';
import Tools from '@/providers/tools';

const edLessonNav = Vue.component('ed-lesson-nav', {
  props: ['nav', 'viewOptions'],
  data: () => {
    return {
      gridView: KEYS.VIEW_SELECTION.GRID_VIEW,
      listView: KEYS.VIEW_SELECTION.LIST_VIEW
    }
  },
  methods: {
    select (i) {
      this.$emit('select', i);
    },
    changeViewType(viewType) {
      Tools.setCookie(KEYS.COOKIES.VIEW_SELECTION_COOKIE, viewType);
    }
  },
  computed: {
    gridActive() {
      let active = '';
      if(this.viewOptions) {
        active = this.$store.state.viewType === KEYS.VIEW_SELECTION.GRID_VIEW ? 'ed-icon--active' : '';
      }
      return active;
    },
    listActive() {
      let active = '';
      if(this.viewOptions) {
        active = this.$store.state.viewType === KEYS.VIEW_SELECTION.LIST_VIEW ? 'ed-icon--active' : '';
      }
      return active;
    }
  },
  components: {
    EdLessonNavLink
  }
});

export default edLessonNav;
